import React from "react";
import { ReactComponent as MyProfileClientIcon } from "icons/user-icon.svg";
import { ReactComponent as CompanyProfileIcon } from "icons/suitcase.svg";
import { FiEye } from "react-icons/fi";
import { BaseMemberPaths } from "newui/utils/navigation/navigation.types";
import { AppMenuItem } from "./AppMenuItem/AppMenuItem";
import { SettingsExpandableMenu } from "./SettingsExpandableMenu";

interface AppMenuCommonBottomItemsProps {
  exactProfileLinks?: boolean;
  isCollapsed: boolean;
  paths: BaseMemberPaths;
  onNavigate?: () => void;
}

export const AppMenuCommonBottomItems: React.FC<AppMenuCommonBottomItemsProps> = ({
  isCollapsed,
  paths,
  exactProfileLinks = false,
  onNavigate,
}) => {
  return (
    <>
      <AppMenuItem
        name="Preview Profile"
        icon={<FiEye size={24} />}
        link={`/${paths.previewProfile}`}
        type="tab"
        isCollapsed={isCollapsed}
        testId="preview-profile"
        tourName="PreviewProfile"
      />
      <AppMenuItem
        name="Company Profile"
        icon={<CompanyProfileIcon />}
        link={paths.companyProfile.information}
        exactLink={exactProfileLinks}
        isCollapsed={isCollapsed}
        testId="company-profile"
        tourName="CompanyProfile"
        onNavigate={onNavigate}
      />
      <AppMenuItem
        name="My Profile"
        icon={<MyProfileClientIcon />}
        link={paths.myProfile}
        exactLink={exactProfileLinks}
        isCollapsed={isCollapsed}
        testId="my-profile"
        tourName="MyProfile"
        onNavigate={onNavigate}
      />
      <SettingsExpandableMenu
        isCollapsed={isCollapsed}
        paths={paths}
        onNavigate={onNavigate}
      />
    </>
  );
};
